<template>
	<div id="app">
		<router-view v-slot="{ Component }">
			<component class="router-view" :is="Component" />
		</router-view>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'App',
	computed: {
		user () {
			return this.$store.state.user
		}
	},
	async created () {
		await this.fetchUserData()
	},
	watch: {
		async user () {
			await this.fetchUserData()
		}
	},
	methods: {
		async fetchUserData () {
			if (this.$store.getters.authorized) {
				await this.$store.dispatch('schema/fetchEntities')
				await this.$store.dispatch('properties/fetchProperties')
				await this.$store.dispatch('lists/fetchLists')
				await this.$store.dispatch('graph/fetchDefinitions')
			}
		}
	},
})
</script>

<style scoped>

</style>
